export default {
      id: "event-company-profile-header-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#event-company-profile-header",
      toString: function () {
        return this.url;
      }
    }